var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex scale" },
    _vm._l(_vm.guideData, function(index) {
      return _c(
        "div",
        {
          key: index.id,
          staticClass: "scale-button-container flex flex-column align-center"
        },
        [
          _c(
            "div",
            {
              staticClass: "scale-button flex",
              class: {
                selected: _vm.active == index.id,
                "small-button": _vm.activeSector.id > 6
              },
              on: {
                click: function($event) {
                  return _vm.sendAnswer(index.id)
                }
              }
            },
            [_c("div", [_vm._v(_vm._s(index.description))])]
          ),
          false
            ? _c("div", { staticClass: "scale-button-description" }, [
                _vm._v(_vm._s(_vm.buttonText(index)))
              ])
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }